import { api } from "../App";
import { createNotification } from "../components/Notifications/Notifications";
import {
  GET_TRACK_PROFILE_LIST,
  GET_TRACK_PROFILE_CURR,
  GET_STUDY_SHIFTS_LIST,
  GET_STUDY_MANNERS_LIST,
  GET_HOMEWORKS,
  GET_DIGITAL_EXAM_BOOK,
  GET_JORNAL_CONTROL,
  GET_JOURNAL_MANNERS_LIST,
  GET_JORNAL_CONTROL_COURSES,
  GET_HOMEWORK_LIST_BASEEDUC,
  GET_SUBGROUP_LIST_COURSES,
  GET_SUBGROUP_TABLES_LIST,
  GET_SUBGROUP_CLASS_LIST,
  GET_SUBGROUP_BY_ID,
  GET_SUBGROUP_GROUPUSER,
  GET_SUBGROUP_AVAILABLE_GROUPS,
  GET_SUBGROUP_AVAILABLE_STUDENTS,
  GET_SUBGROUP_MAIN,
  GET_SUBGROUP_MEMBERS,
  GET_SUBGROUP_HISTORY,
  GET_SUBGROUP_CANDIDATES,
  GET_SUBGROUP_ELECTIVE_YEARS,
  GET_SUBGROUP_OWNER_HISTORY,
} from "./types";


// <----  ПРОФИЛИ ОБУЧЕНИЯ ---->

export const getTrackProfileList = () => async (dispatch) => {
  try {
    const { data } = await api.get(`/track_profile`);
    dispatch({ type: GET_TRACK_PROFILE_LIST, payload: data });
  } catch (ERR) {
  }
};

export const getTrackProfileCurr = (id) => async (dispatch) => {
  try {
    const { data } = await api.get(`/track_profile/${id}`);
    dispatch({ type: GET_TRACK_PROFILE_CURR, payload: data });
  } catch (ERR) {
  }
};

export const updateTrackProfile = (params, closeModal) => async (dispatch) => {
  try {
    await api.put(`/track_profile/${params.trp_id}`, params);
    createNotification('success', 'Успешно');
    await dispatch(getTrackProfileList());
    closeModal();
  } catch (error) {
    const errorMessage = error.response?.data?.error || 'Не удалось изменить запись';
    createNotification('error', errorMessage);
  }
}

export const createTrackProfile = (reqData, closeModal) => async (dispatch) => {
  try {
    await api.post(`/track_profile`, reqData);
    createNotification('success', 'Успешно');
    await dispatch(getTrackProfileList());
    closeModal();
  } catch (error) {
    const errorMessage = error.response?.data?.error || 'Не удалось создать запись';
    createNotification('error', errorMessage);
  }
};

export const deleteTrackProfile = (id) => async (dispatch) => {
  try {
    await api.delete(`/track_profile/${id}`);
    createNotification('success', 'Успешно');
    await dispatch(getTrackProfileList());
  } catch (error) {
    const message = error.response?.data?.error || 'Ошибка';
    createNotification('error', message);
  }
};

// <----  УЧЕБНЫЕ СМЕНЫ ---->

export const getStudyShiftsList = () => async (dispatch) => {
  try {
    const { data } = await api.get(`/shifts`);
    dispatch({ type: GET_STUDY_SHIFTS_LIST, payload: data });
  } catch (ERR) {
  }
};

export const updateStudyShift = (params, closeModal) => async (dispatch) => {
  try {
    await api.put(`/shifts/${params.sid}`, params);
    createNotification('success', 'Успешно');
    await dispatch(getStudyShiftsList());
    closeModal?.();
  } catch (ERR) {
    createNotification('error', "Не удалось изменить запись");
  }
}

export const createStudyShift = (reqData, closeModal) => async (dispatch) => {
  try {
    await api.post(`/shifts`, reqData);
    createNotification('success', 'Успешно');
    await dispatch(getStudyShiftsList());
    closeModal?.();
  } catch (ERR) {
    createNotification('error', "Не удалось создать запись");
  }
};

export const deleteStudyShift = (id) => async (dispatch) => {
  try {
    await api.delete(`/shifts/${id}`);
    createNotification('success', 'Успешно');
    await dispatch(getStudyShiftsList());
  } catch (error) {
    const message = error.response?.data?.error || 'Ошибка';
    createNotification('error', message);
  }
};

// <----  Критерии воспитанности ---->

export const getMannersList = () => async (dispatch) => {
  try {
    const { data } = await api.get(`/manners`);
    dispatch({ type: GET_STUDY_MANNERS_LIST, payload: data });
  } catch (ERR) {
  }
};

export const updateManners = (params) => async (dispatch) => {
  try {
    await api.put(`/manners/${params.id}`, params);
    await dispatch(getMannersList());
  } catch (ERR) {
  }
}

export const createManners = (reqData) => async (dispatch) => {
  try {
    await api.post(`/manners`, reqData);
    createNotification('success', 'Успешно');
    await dispatch(getMannersList());
  } catch (ERR) {
    createNotification('error', "Не удалось создать запись");
  }
};

export const deleteManners = (id) => async (dispatch) => {
  try {
    await api.delete(`/manners/${id}`);
    createNotification('success', 'Успешно');
    await dispatch(getMannersList());
  } catch (error) {
    const message = error.response?.data?.error || 'Ошибка';
    createNotification('error', message);
  }
};

// <----  ЖУРНАЛ воспитанности ---->

export const getJournalMannersList = (reqData) => async (dispatch) => {
  const { group_id, manner_id, trimestr } = reqData;
  try {
    const { data } = await api.get(`/manners_journal/${trimestr}/${manner_id}/${group_id}`);
    dispatch({ type: GET_JOURNAL_MANNERS_LIST, payload: data });
  } catch (ERR) {
  }
};

// <---- Домашние задания  ---->
export const getHomeworks = (id) => async (dispatch) => {
  try {
    const { data } = await api.get(`/homeworks/${id}`)
    dispatch({ type: GET_HOMEWORKS, payload: data })
  } catch (ERR) {
    console.log(ERR)
  }
};

export const updateHomeworks = (id, reqData) => async (dispatch) => {
  try {
    await api.put(`/homeworks/${id}`, reqData)
  } catch (ERR) {
    console.log(ERR)
  }
};

export const createHomeworks = (reqData) => async (dispatch) => {
  try {
    await api.post('/homeworks', reqData)
  } catch (ERR) {
    console.log(ERR)
  }
};

export const deleteHomeworks = (id) => async (dispatch) => {
  try {
    await api.delete(`/homeworks/${id}`)
  } catch (ERR) {
    console.log(ERR)
  }
};

// <---- Электронная зачетка  ---->
export const getDigitalExamBook = (params) => async (dispatch) => {
  try {
    const { data } = await api.get(`/student_record_book`, { params })
    dispatch({ type: GET_DIGITAL_EXAM_BOOK, payload: data })
  } catch (ERR) {
    console.log(ERR)
  }
};

// <---- Контроль ведения классного журнала  ---->
export const getJournalControl = (params) => async (dispatch) => {
  try {
    const { data } = await api.get(`/journal_control`, { params })
    dispatch({ type: GET_JORNAL_CONTROL, payload: data })
  } catch (ERR) {
    console.log(ERR)
  }
};

export const getJournalControlCourses = () => async (dispatch) => {
  try {
    const { data } = await api.get(`/journal_control/courses`)
    dispatch({ type: GET_JORNAL_CONTROL_COURSES, payload: data })
  } catch (ERR) {
    console.log(ERR)
  }
};

export const updateJournalControlElement = (id, reqData) => async (dispatch) => {
  try {
    await api.put(`/journal_control/${id}`, reqData)
  } catch (ERR) {
    console.log(ERR)
  }
};

export const createJournalControlElement = (reqData) => async (dispatch) => {
  const { gid, trmid } = reqData
  const payload = { gid, trmid }
  try {
    await api.post('/journal_control', reqData)
    dispatch(getJournalControl(payload))
  } catch (ERR) {
    console.log(ERR)
  }
};

// <---- Домашние задания (список) ---->
export const getHomeworkList = ({ gid, ...params }) => async (dispatch) => {
  try {
    const { data } = await api.get(`/homework/${gid}`, { params })
    dispatch({ type: GET_HOMEWORK_LIST_BASEEDUC, payload: data })
  } catch (ERR) {
    console.log(ERR)
  }
};

// <---- Подгруппы ---->

export const deleteSubgroup = (gid, refreshParams) => async (dispatch) => {
  try {
    await api.delete(`/groups/${gid}`);
    createNotification('success', 'Подгруппа успешно удалена');
    if (refreshParams) {
      await dispatch(getSubgroupTablesList(refreshParams));
    }
  } catch (ERR) {
    console.error(ERR);
    createNotification('error', 'Не удалось удалить подгруппу');
  }
};

export const getSubgroupList = ({ school_year_id, cid }) => async (dispatch) => {
  try {
    const { data } = await api.get(`/subgroups/group`, { params: { school_year_id, cid } })
    dispatch({ type: GET_SUBGROUP_CLASS_LIST, payload: data.data })
  } catch (ERR) {
    console.error(ERR)
    createNotification('error', 'Не удалось загрузить список классов')
  }
}

export const getSubgroupCoursesList = ({ school_year_id, show_closed }) => async (dispatch) => {
  try {
    const { data } = await api.get(`/subgroups/courses`, { params: { school_year_id, show_closed } })
    dispatch({ type: GET_SUBGROUP_LIST_COURSES, payload: data.data })
  } catch (ERR) {
    console.error(ERR)
    createNotification('error', 'Не удалось загрузить список предметов')
  }
};

export const getSubgroupTablesList = ({ school_year_id, show_closed, cid, gid, is_elective }) => async (dispatch) => {
  try {
    const { data } = await api.get(`/subgroups`, { params: { school_year_id, cid, gid, is_elective, show_closed } })
    dispatch({ type: GET_SUBGROUP_TABLES_LIST, payload: data?.data })
  } catch (ERR) {
    console.error(ERR)
    createNotification('error', 'Не удалось загрузить таблицу подгрупп')
  }
};

export const getSubgroupById = (gid) => async (dispatch) => {
  try {
    const { data } = await api.get(`/groups/subgroup/${gid}`)
    dispatch({ type: GET_SUBGROUP_BY_ID, payload: data })
  } catch (ERR) {
    console.error(ERR)
    createNotification('error', 'Не удалось загрузить данные подгруппы')
  }
};

export const createSubgroup = (reqData) => async (dispatch) => {
  try {
    await api.post('/subgroups', reqData)
    createNotification('success', 'Подгруппа успешно создана')
  } catch (ERR) {
    console.error(ERR)
    createNotification('error', 'Не удалось создать подгруппу')
  }
};

export const updateSubgroup = (reqData) => async (dispatch) => {
  try {
    await api.put(`/groups/${reqData.gid}`, reqData)
    createNotification('success', 'Подгруппа успешно обновлена')
  } catch (ERR) {
    console.error(ERR)
    createNotification('error', 'Не удалось обновить подгруппу')
  }
};

export const getSubgroupGroupuser = (params) => async (dispatch) => {
  const { cid, gid } = params
  try {
    const { data } = await api.get(`/groupuser_transfer/${cid}/${gid}`)
    dispatch({ type: GET_SUBGROUP_GROUPUSER, payload: data })
  } catch (ERR) {
    console.error(ERR)
    createNotification('error', 'Не удалось загрузить состав подгруппы')
  }
};

export const createSubgroupGroupuser = (reqData) => async (dispatch) => {
  try {
    await api.post('/groups/subgroup', reqData)
    createNotification('success', 'Ученик успешно зачислен')
  } catch (ERR) {
    console.error(ERR)
    createNotification('error', 'Не удалось зачислить ученика')
  }
};

export const getSubgroupAvailableGroups = () => async (dispatch) => {
  try {
    const { data } = await api.get(`/groups/year/liter`);
    dispatch({ type: GET_SUBGROUP_AVAILABLE_GROUPS, payload: data });
  } catch (ERR) {
    console.error(ERR);
    createNotification('error', 'Не удалось загрузить классы');
  }
};

export const getSubgroupAvailableStudents = (gid) => async (dispatch) => {
  try {
    const { data } = await api.get(`/groups/${gid}/listeners`);
    dispatch({ type: GET_SUBGROUP_AVAILABLE_STUDENTS, payload: data });
  } catch (ERR) {
    console.error(ERR);
    createNotification('error', 'Не удалось загрузить учеников');
  }
};

// ===== Новое API подгрупп =====

export const getSubgroupMain = (gid) => async (dispatch) => {
  try {
    const { data } = await api.get(`/subgroups/${gid}`, { params: { tab: 'main' } });
    dispatch({ type: GET_SUBGROUP_MAIN, payload: data });
  } catch (ERR) {
    console.error(ERR);
    createNotification('error', 'Не удалось загрузить данные подгруппы');
  }
};

export const getSubgroupMembers = (gid) => async (dispatch) => {
  try {
    const { data } = await api.get(`/subgroups/${gid}`, { params: { tab: 'members' } });
    dispatch({ type: GET_SUBGROUP_MEMBERS, payload: data?.data || data });
  } catch (ERR) {
    console.error(ERR);
    createNotification('error', 'Не удалось загрузить состав подгруппы');
  }
};

export const getSubgroupHistoryTab = (gid) => async (dispatch) => {
  try {
    const { data } = await api.get(`/subgroups/${gid}`, { params: { tab: 'history' } });
    dispatch({ type: GET_SUBGROUP_HISTORY, payload: data });
  } catch (ERR) {
    console.error(ERR);
    createNotification('error', 'Не удалось загрузить историю подгруппы');
  }
};

export const getSubgroupCandidates = (gid, date, par) => async (dispatch) => {
  try {
    const params = { ...date };
    if (par && Array.isArray(par)) {
      params.years = par.map(item => item.year);
    }
    const { data } = await api.get(`/subgroups/${gid}/members/candidates`, { params });
    dispatch({ type: GET_SUBGROUP_CANDIDATES, payload: data?.data || data });
  } catch (ERR) {
    console.error(ERR);
    createNotification('error', 'Не удалось загрузить кандидатов');
  }
};

export const enrollSubgroupMembers = (gid, date, midList) => async (dispatch) => {
  try {
    await api.post(`/subgroups/${gid}/members/enroll`, {
      date,
      mid_list: midList
    });
    createNotification('success', 'Учащиеся успешно зачислены');
    dispatch(getSubgroupMembers(gid));
    return true;
  } catch (ERR) {
    console.error(ERR);
    createNotification('error', ERR?.response?.data?.detail || 'Не удалось зачислить учащихся');
    return false;
  }
};

export const expelSubgroupMembers = (gid, date, midList) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/subgroups/${gid}/members/expel`, {
      data: { date, mid_list: midList }
    });
    if (!data?.count) {
      createNotification('error', 'Отчислить можно только датой позже даты зачисления');
      return false;
    }
    createNotification('success', 'Учащиеся успешно отчислены');
    dispatch(getSubgroupMembers(gid));
    return true;
  } catch (ERR) {
    console.error(ERR);
    createNotification('error', ERR?.response?.data?.detail || 'Не удалось отчислить учащихся');
    return false;
  }
};

// История родительского класса (для автозаполнения вкладки «История» при создании)
export const getSubgroupOwnerHistory = (ownerGid) => async (dispatch) => {
  try {
    const { data } = await api.get(`/group_history/${ownerGid}`);
    dispatch({ type: GET_SUBGROUP_OWNER_HISTORY, payload: data });
  } catch (ERR) {
    console.error(ERR);
  }
};

export const getSubgroupElectiveYears = (schoolYearId, cid) => async (dispatch) => {
  try {
    const { data } = await api.get(`/subgroups/elective_years`, { params: { school_year_id: schoolYearId, cid } });
    dispatch({ type: GET_SUBGROUP_ELECTIVE_YEARS, payload: data });
  } catch (ERR) {
    console.error(ERR);
    createNotification('error', 'Не удалось загрузить годы обучения');
  }
};

export const createSubgroupNew = (mainData, historyData, refreshParams) => async (dispatch) => {
  try {
    const { data } = await api.post('/subgroups', {
      main: mainData,
      history: historyData || []
    });
    createNotification('success', 'Подгруппа успешно создана');
    if (refreshParams) {
      dispatch(getSubgroupTablesList(refreshParams));
    }
    return data;
  } catch (ERR) {
    console.error(ERR);
    createNotification('error', 'Не удалось создать подгруппу');
    return null;
  }
};

export const updateSubgroupNew = (gid, mainData, historyData, refreshParams) => async (dispatch) => {
  try {
    await api.put(`/subgroups/${gid}`, {
      main: mainData,
      history: historyData
    });
    createNotification('success', 'Подгруппа успешно обновлена');
    if (refreshParams) {
      dispatch(getSubgroupTablesList(refreshParams));
    }
  } catch (ERR) {
    console.error(ERR);
    createNotification('error', 'Не удалось обновить подгруппу');
  }
};

export const deleteSubgroupNew = (gid, refreshParams) => async (dispatch) => {
  try {
    await api.delete(`/subgroups/${gid}`);
    createNotification('success', 'Подгруппа успешно удалена');
    if (refreshParams) {
      dispatch(getSubgroupTablesList(refreshParams));
    }
  } catch (ERR) {
    console.error(ERR);
    createNotification('error', 'Не удалось удалить подгруппу');
  }
};
